import { gql } from '__generated__';

export default gql(`
  query GetOrdersForBackend(
    $project_id: ID!,
    $page: Int,
    $per_page: Int,
    $search: String,
    $events: [ID!],
    $created_after: String,
    $created_before: String,
    $participant_fields: [ParticipantFieldFilter!],
    $participant_field_choices: [ID!],
    $purchase_filters: PurchaseFilters,
    $participant_filters: ParticipantFilters,
  ) {
    project(id: $project_id) {
      id
      events {
        total
      }
      orders(
        page: $page,
        per_page: $per_page,
        events: $events,
        search: $search,
        created_after: $created_after,
        created_before: $created_before,
        participant_fields: $participant_fields,
        participant_field_choices: $participant_field_choices,
        purchase_filters: $purchase_filters,
        participant_filters: $participant_filters,
      ) {
        data {
          id
          event {
            id
            title
          }
          participant {
            id
            full_name
          }
          invoice_date
          draft
          invoice_id
          company_name
          amount
          balance
          remaining_amount
          refunded_amount
          cancelled
          waitlist
          preregistration
          tickets_count
        }
        current_page
        per_page
        has_more_pages
      }
    }
  }
`);
